import { Submission, UserOnboarding } from "types/userTypes";
import { UserActionType } from "../action-types/userActionTypes";
import {
  USER_SET_IS_ACTIVE,
  USER_SET_LOG_OUT,
  USER_SET_ORG,
  USER_SET_SUBMISSIONS,
  USER_SET_ROLE,
  USER_SET_FORCE_PASS_CHANGE,
  USER_SET_DISTRIBUTOR_ID,
  USER_SET_ONBOARDING,
} from "../constants";

export type UserState = {
  loggedIn: boolean;
  role: string;
  orgId: string;
  forcePassChange: boolean;
  isActive: boolean;
  distId: string | null;
  receivedRequests: Submission[];
  onboarding: UserOnboarding | null;
};

const defaultState: UserState = {
  loggedIn: false,
  role: "",
  orgId: "",
  isActive: true,
  forcePassChange: false,
  distId: null,
  receivedRequests: [],
  onboarding: null,
};

const userReducer = (state: UserState = defaultState, action: UserActionType): UserState => {
  switch (action.type) {
    case USER_SET_ROLE:
      return {
        ...state,
        loggedIn: true,
        role: action.payload,
      };
    case USER_SET_ORG:
      return {
        ...state,
        loggedIn: true,
        orgId: action.payload,
      };
    case USER_SET_IS_ACTIVE:
      return {
        ...state,
        isActive: action.payload,
      };
    case USER_SET_FORCE_PASS_CHANGE:
      return {
        ...state,
        forcePassChange: action.payload,
      };
    case USER_SET_LOG_OUT:
      return defaultState;
    case USER_SET_SUBMISSIONS:
      return {
        ...state,
        receivedRequests: action.payload,
      };
    case USER_SET_DISTRIBUTOR_ID:
      return {
        ...state,
        distId: action.payload,
      };
    case USER_SET_ONBOARDING:
      return {
        ...state,
        onboarding: action.payload,
      };
    default:
      return state;
  }
};

export default userReducer;
